// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.escher-container .default-tooltip {
  box-sizing: border-box;
  min-width: 300px;
  min-height: 100px;
  border-radius: 2px;
  border: 1px solid #b58787;
  padding: 7px;
  background-color: #fff;
  text-align: left;
  font-size: 16px;
  font-family: sans-serif;
  color: #111;
  box-shadow: 4px 6px 20px 0px rgba(0, 0, 0, 0.4);
}

.escher-container .default-tooltip .id{
  font-size: 18px;
  font-weight: bold;
}

.escher-container .default-tooltip button {
  border-radius: 3px;
  background-color: #eee;
  border: 1px solid #ddd;
  margin-top: 4px;
  font-size: 16px;
  padding: 3px 6px;
}

.escher-container .default-tooltip .top-right {
  position: absolute;
  top: 4px;
  right: 4px;
}

.escher-container .default-tooltip .top-right * {
  float: right;
  text-align: right;
}

.escher-container .default-tooltip .top-right a {
  font-size: 11px;
  color: #999;
  cursor: pointer;
}
.escher-container .default-tooltip .top-right a:hover {
  color: #444;
  text-decoration: underline;
}

.escher-container .default-tooltip .type-label {
  font-size: 15px;
  color: #d27066;
  background-color: #ffeded;
  border-radius: 2px;
  margin: 0 0 0 10px;
  padding: 0 5px;
}
`, "",{"version":3,"sources":["webpack://./src/DefaultTooltip.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,WAAW;EACX,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;AACA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB","sourcesContent":[".escher-container .default-tooltip {\n  box-sizing: border-box;\n  min-width: 300px;\n  min-height: 100px;\n  border-radius: 2px;\n  border: 1px solid #b58787;\n  padding: 7px;\n  background-color: #fff;\n  text-align: left;\n  font-size: 16px;\n  font-family: sans-serif;\n  color: #111;\n  box-shadow: 4px 6px 20px 0px rgba(0, 0, 0, 0.4);\n}\n\n.escher-container .default-tooltip .id{\n  font-size: 18px;\n  font-weight: bold;\n}\n\n.escher-container .default-tooltip button {\n  border-radius: 3px;\n  background-color: #eee;\n  border: 1px solid #ddd;\n  margin-top: 4px;\n  font-size: 16px;\n  padding: 3px 6px;\n}\n\n.escher-container .default-tooltip .top-right {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n}\n\n.escher-container .default-tooltip .top-right * {\n  float: right;\n  text-align: right;\n}\n\n.escher-container .default-tooltip .top-right a {\n  font-size: 11px;\n  color: #999;\n  cursor: pointer;\n}\n.escher-container .default-tooltip .top-right a:hover {\n  color: #444;\n  text-decoration: underline;\n}\n\n.escher-container .default-tooltip .type-label {\n  font-size: 15px;\n  color: #d27066;\n  background-color: #ffeded;\n  border-radius: 2px;\n  margin: 0 0 0 10px;\n  padding: 0 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
